import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep, debounce } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '../../../components/CustomTable';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import ExpandTable from './ExpandTable';
import DatePicker from '../../../components/Datepicker';
import './campaign.scss';
import { checkPermission } from '../../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission, checkTablePermissionForRedirectDashboard } from '../../../utils/route-auth';
import { PERMISSION } from '../../../constants/permission';
import { Modal } from 'semantic-ui-react';
import { getValidCampaignsId, isApiCallSuccess, isTenantAgency, getTenantCurrency, getDateFromUtcToSpecificZone, getTenantTimeZone, getCurrentDateInTimeZone, isTenantDemoAdvertiser } from '../../../selectors/index';
import { campaignListAllReportData, sortArray } from '../../../selectors';
import { options, formFields, optionsError, noMetricMessage, campaignListMessages } from './constant';
import { handleFieldError, handleError } from '../../../utils/form-validation';

import {
  getCampaignListAllReportAction,
  getIoAdvertisersReportAction,
  deleteCampaignAction,
  getCampaignEditIdReportAction,
  addCampaignAction,
  getCountryAction,
  getPrivateMarketPlaceAction,
  postCampaignListAllAction,
  getCampaignCustomAction,
  updateCampaignStatusAction,
  getCampaignListByIdAction,
  getPaymentRelatedAccessAction,
  getCampaignFilterAction,
  postCampaignFilterAction,
  postCampaignStatusAction,
  campaignSearchAction,
  postCampaignAvailableDashboadDataAction,
  clearAllReduxDataDashoardScreen1
} from '../../../actions';
import { basicDetailsReduxAction } from '../../../actions/basicDetails';
import { customPlanReduxAction, setStepperEditAction } from '../../../actions/customPlanDetails'
import { strategyListReduxAction } from '../../../actions/strategyDetails';
import Select from "react-select";
import CreateOwnCampaignImage from "../../../assets/images/creteOwnCampaign.png";
import CreateRecomendedImage from "../../../assets/images/createRecommendedPlan.png";
import ToastModal from "../../../components/ToastModal";
import { useCurrentPlanData } from "../../../hooks/useCurrentPlanData";
import { useFetchCurrencyListData } from "../../../hooks/useFetchCurrencyListData";
import SubspendMessage from '../../../components/SuspendMessage';
import { accessCheck } from '../../../helpers/planAccessConstant/constant';
import { recommendedPlanAction, setPreferenceListReduxAction } from '../../../actions/recommendedPlan';
import { strategyCreativeDataAction } from '../../../actions/creative';
import { defaultPlatformConfig } from '../../../constants/configuration';
import { postCampaignAction, reduxCampaignDataAction, reduxDataForAccordianOpenCampaignAction } from '../../../actions/campaign';
import { message } from 'antd';
import { campaignFilterData, campaignList } from "../../../constants/demo/campaignData"
import { infoMessages } from '../../../constants/demo/constant';


const Tabs = asyncRoute(() => import('../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));
const Input = asyncRoute(() => import('../../../components/FormElements/Input'));
const Spinner = asyncRoute(() => import('../../../components/Spinner'));

const date = [{ id: 1, value: 'Active' }, { id: 0, value: 'Inactive' }];

const Campaign = (props) => {
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [allCampaignList, setAllCampaignList] = useState([]);
  const [form, setForm] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);
  const [optionsList, setOptionsList] = useState(options);
  const [viewCampaign, setViewCampaign] = useState(false);
  const [listCampaignModal, setListCampaignModal] = useState([]);
  const [dashboardCampaignIds, setDashboardCampaignIds] = useState([]);
  const [campModalValue, setCampModalValue] = useState({});
  const [campaignsData, setCampaignsData] = useState([]);
  const [platformsData, setPlatformsData] = useState([]);
  const [creativeTypesData, setCreativeTypesData] = useState([]);
  const [advertiserFilter, setAdvertiserFilter] = useState({ label: "All", value: -1 });
  const [bekiCampaignFilter, setBekiCampaignFilter] = useState([]);
  const [platformCampaignFilter, setPlatformCampaignFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [triggerListCampaign, setTriggerListCampaign] = useState(false);
  const [currentIndexForPagination, setCurrentIndexForPagination] = useState(1);
  const [enableToast, setEnableToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastMsg, setToastMsg] = useState("");
  const [confirmationMsg, setConfirmationMsg] = useState("");
  const [method, setMethod] = useState("");
  const [deleteData, setDeleteData] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [listApiCall, setListApiCall] = useState(false);
  const [viewError, setViewError] = useState(false);
  const [showSuspendDiv, setShowSuspendDiv] = useState(false);
  const [isSemiSuspendedOrNot, setIsSemiSuspendedOrNot] = useState('');
  const [campaignAcessDetails, setCampaignAccessDetails] = useState({});
  const [istenantAgency, setIstenantAgency] = useState('');
  const [isPlatformManager, setIsPlatformManager] = useState('');
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({ /* initial errors state */ });
  const [submited, setSubmited] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [advertiserData, setAdvertiserData] = useState(null);
  const [bekiCampaignData, setBekiCampaignData] = useState(null);
  const [platformCampaignData, setPlatformCampaignData] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const [renderComponent, setRenderComponent] = useState(false);
  const [isRecommendedPlanSelected, setIsRecommendedPlanSelected] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [searchParams, setSearchParams] = useState('');
  const [campaignListDataInitial, setCampaignListDataInitial] = useState([])
  const [isInitialApiCallCompleted, setIsInitialApiCallCompleted] = useState(false)
  const [budgetLabel, setBudgetLabel] = useState('');



  const configurationList = useSelector(state => get(state, 'app.configurationData.responseList', []));
  const campaignListAllReport = useSelector(state => get(state, 'app.campaignListAllReport.responseList', []));
  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const camapignAccess = useSelector((state) => get(state, "app.subscriptionCurrentData", {}));
  const recoAccess = useSelector((state) => get(state, "app.subscriptionCurrentData.recommendedPlan", []));
  const platformConfiguration = useSelector(state => get(state, 'app.platformConfiguration', {}));

  const dispatch = useDispatch();
  const currentPlanData = useCurrentPlanData();
  const currencyData = useFetchCurrencyListData();
  const popoverRef = useRef(null);


  const targetTimeZone = getTenantTimeZone(tenantId);



  // if (!istenantAgency ||  (!istenantAgency && advertiserFilter.label != 'All')) {
  //   const columnIndex = options.columns.findIndex(column => column.id == 5);
  //   console.log("columnindex",columnIndex)
  //   if (columnIndex !== -1) {
  //     options.columns.splice(columnIndex, 1);
  //   }
  // }
  // console.log("istenantAgency",istenantAgency)
  // console.log("advertiserFilter",advertiserFilter)
  // console.log("options",options)



  const formFields = {
    search: {
      key: 'search',
      type: 'string',
      label: '',
      displayLayout: 'col-md-11',
      placeholder: "Search"
    },

  }

  const isDemoAdvertiser = useMemo(() => {
    return isTenantDemoAdvertiser(tenantId);
  }, [tenantId]);


  useEffect(() => {
    if (currencyData && currencyData.length > 0 && targetTimeZone) {
      // console.log("props",props)
      setIstenantAgency(isTenantAgency(tenantId));


      if (isEmpty(JSON.parse(localStorage.getItem('AuthData')))) {
        props.history.push(routes.preSignIn);
      }
      const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"));
      const Isplat = dataLocal.responseList[0].tenantType;
      setIsPlatformManager(Isplat);

      if (Isplat !== "Platform Manager") {
        // AcessValidate();
      }

      let optionCloned = _.cloneDeep(options);
      let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
      optionCloned = checkTablePermission({ add: PERMISSION.CAMPAIGN.CAMPAIGN.ADD, edit: PERMISSION.CAMPAIGN.CAMPAIGN.EDIT, view: PERMISSION.CAMPAIGN.CAMPAIGN.VIEW }, optionCloned);
      optionCloned.columns.forEach((dataCol, index) => {
        if (dataCol.name == "recos") {
          optionCloned.columns[index].component = (row) => <div class="d-flex align-items-center">{row.recos} <a>
            {
              row.recos == 1 && <i onClick={() => { routeToOptimiser(props.history, row) }} style={{ cursor: 'pointer' }} class="ti ti-external-link ti-xs pl-1 text-primary"></i>
            }
          </a> </div>
        }
        if (dataCol['containsPlatformName']) {
          dataCol['label'] = dataCol['label'].toLowerCase().replace('beki', platformName).toUpperCase();
        }
        if (dataCol.name == "budget") {
          let label = 'BUDGET';
          let currencyLabel = '';
          let tenantCurrency = getTenantCurrency(tenantId);
          if (currencyData && currencyData.length > 0) {
            tenantCurrency = currencyData.find(item => item.key == tenantCurrency);
            currencyLabel = tenantCurrency && tenantCurrency.hasOwnProperty('value') ? tenantCurrency['value'] : '';
            if (currencyLabel !== '')
              currencyLabel = `(${currencyLabel})`;
          }
          label = `${label} ${currencyLabel}`;
          dataCol.label = label;
          setBudgetLabel(label);
        }

        if (dataCol.name == "startDate") {
          optionCloned.columns[index].component = (row) => row.startDate ? moment(getDateFromUtcToSpecificZone({ date: row.startDate, targetTimeZone: targetTimeZone })).format('D-MMM-YY') : '-'
        }
        if (dataCol.name == "endDate") {
          optionCloned.columns[index].component = (row) => row.endDate ? moment(getDateFromUtcToSpecificZone({ date: row.endDate, targetTimeZone: targetTimeZone })).format('D-MMM-YY') : '-'
        }
      })



      setOptionsList(optionCloned);

      initializeListApiCall();
    }
  }, [currencyData, targetTimeZone]);

  // SEARCH
  // useEffect(() => {
  //   if (searchParams.length > 0) {
  //     clearTimeout(searchTimeout);
  //     setSearchTimeout(setTimeout(() => searchCampaign(), 300));
  //   }
  //   else {
  //     setListCampaignModal(campaignListDataInitial)
  //   }
  // }, [searchParams])

  const debouncedSearch = debounce((query) => {
    // Perform the search operation here
    searchCampaign(query);
  }, 800);


  // console.log(moment(getDateFromUtcToSpecificZone({date:"2024-06-07 09:59:59", targetTimeZone:targetTimeZone})).format('D-MMM-YY'));

  const routeToOptimiser = (history, row) => {
    history.push(`/${routes.mainRoute}/${routes.containers.optimizer}/${routes.optimizer.recommendations}/${row.advertiserId ? row.advertiserId : -1}`)
  }


  const initializeListApiCall = async () => {
    try {
      setShowSpinner(true);
      await listCampaignFilter();
      await listCampaign();
    }
    catch (err) {
      setShowSpinner(false);
    }
  }

  const AcessValidate = async () => {
    // const { tenantId, userId, authToken, getPaymentRelatedAccessAction, history } = props;
    const { history } = props;
    let campaignAcessDetails = {};
    let paymentAccess;
    let isSemiSuspendedOrNot;

    await dispatch(getPaymentRelatedAccessAction({ tenantId, authToken, userId }))
      .then((data) => {
        const { responseCode: { status = "" }, response } = data;

        if (status === "Success" && response) {
          paymentAccess = response;

          if (paymentAccess.subscriptionDetails && paymentAccess.subscriptionDetails.length > 0) {
            const accessDetails = paymentAccess.subscriptionDetails[0];
            isSemiSuspendedOrNot = accessDetails.atdAccessModel.status;
            campaignAcessDetails = accessDetails.atdAccessModel.accessDetailsList.find((data) => data.screenId === 1);
            setCampaignAccessDetails(campaignAcessDetails);
            setIsSemiSuspendedOrNot(isSemiSuspendedOrNot);
            setShowSuspendDiv(true);
          } else {
            history.push(`/${routes.mainRoute}/${routes.containers.errors}`);
          }
        } else {
          history.push(`/${routes.mainRoute}/${routes.containers.errors}`);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };




  const handleChange = (e) => {
    const { value, name, min } = e.target;
    if (name == 'search') {
      debouncedSearch(value);
      // setSearchParams(value);
      return;
    }

    if (min) {
      value = Math.max(Number(min), Number(value));
    }
    setForm({ ...form, [name]: value });
  };

  const handleRediretion = async (row) => {
    const { history } = props;
    const params = {
      list: "preview"
    }
    if (row.campaigns && row.campaigns.length > 0) {

      if (row.campaigns.length == 1 && row.campaigns[0].synced == 2) {
        message.error(campaignListMessages.noValidCampaigns);
        return;
      }

      const filteredCampaigns = row.campaigns.filter((dataCamp) => dataCamp.status == 0 || dataCamp.status == 1).map((data) => data.campaignId);

      if (filteredCampaigns.length > 0) {
        await dispatch(postCampaignAction({
          tenantId, authToken, userId, params, payload: {
            "mandateId": row.campaignId,
            "campaignIds": filteredCampaigns
          }
        })).then((data) => {
          const { responseCode: { status = "", msg = "" }, response = [] } = data;
          if (isApiCallSuccess(status)) {
            if (response.length > 0) {
              const validCampaignsArray = getValidCampaignsId(response);
              if (validCampaignsArray.length > 0) {
                const objectForCampaignPublish = {
                  isSaveEnabled: false,
                  status: true,
                  redirectScreen: 'campaign-list',
                  publishDataAll: response,
                  payload: {
                    mandateId: parseInt(row.campaignId),
                    campaignIds: validCampaignsArray,
                  },
                };

                dispatch(reduxCampaignDataAction({ data: null }));
                dispatch(reduxDataForAccordianOpenCampaignAction({ data: null }));
                const location = {
                  pathname: `/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.edit}/${row.campaignId}`,
                  state: {
                    data: {
                      objectForCampaignPublish: objectForCampaignPublish,
                    },
                  },
                };
                history.push(location);
              }
              else {
                message.error(campaignListMessages.noValidCampaigns)
              }
            }
          }
        })
      }
      else {
        message.error(campaignListMessages.noValidCampaigns);
      }

    }
    else {
      message.error(campaignListMessages.noValidCampaigns);
    }
  }

  const handleAction = (row, action) => {
    // console.log(row, "::row")
    const { match, history } = props;
    if (action.type === 'edit' && row.status == 3) {
      // dispatch(setStepperEditAction({ stepperValue: 2, screen: 'editSecondary' }));
      // localStorage.setItem("isRecommendedPlan", String(true));
      history.push(`/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.edit}/${row.campaignId}`);
    } else if (action.type === 'edit') {
      dispatch(setStepperEditAction({ stepperValue: 0, screen: '' }));
      // localStorage.setItem("isRecommendedPlan", String(false));
      history.push(`/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.edit}/${row.campaignId}`);
    } else if (action.type === 'view') {
      dispatch(setStepperEditAction({ stepperValue: 0, screen: '' }));
      // localStorage.setItem("isRecommendedPlan", String(false));
      history.push(`/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.view}/${row.campaignId}`);
    } else if (action.type === 'error') {
      setViewError(!viewError);
      setErrorData(row.errorData);
    } else if (action.type === 'chart') {
      routeToDashBoardSecondScreen(row);
    } else if (action.key === "status") {
      if (isDemoAdvertiser) {
        message.info(infoMessages.campaignStatus);
        return
      } else {
        if (row.status == 0) {
          handleRediretion(row);

        }
        else {
          handleStatus(row)
        }
      }
    }
  };


  const handleStatus = async (row) => {

    let payload = {
      bekiCampaignId: row.campaignId,
      platformCampaignId: 0,
      status: row.status == 1 ? 0 : 1,
    };
    // console.log(payload)

    await dispatch(postCampaignStatusAction({ tenantId, authToken, userId, payload })).then((data) => {

      // console.log("data", data)
      const {
        responseCode: { status = "", msg },
        responseCode,
      } = data;

      if (status === "Success") {

        toast(status, msg, "statusUpdate");

      } else {
        console.log("List data not found");
        toast(status, msg, "statusUpdate");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleCampaign = (row) => {
    const findData = listCampaignModal.find(item => item.id === row.id);
    setCampModalValue(findData);
    setViewCampaign(!viewCampaign);
  };

  // list filter options
  const listCampaignFilter = async () => {
    // const { tenantId, authToken, userId, getCampaignCustomAction, configurationList } = this.props;
    // const { istenantAgency } = this.state;

    await dispatch(getCampaignFilterAction({ tenantId, authToken, userId })).then((data) => {

      const {
        responseCode: { status = "" },
        responseObj,
      } = data;

      if (status === "Success") {

        const advsData = responseObj.advertiserId.map((item, index) => {
          return { label: item.value, value: item.key };
        });

        const bekiCampaign = responseObj.bekiCampaign.map((item, index) => {
          return { label: item.value, value: item.key };
        });

        const platformCampaign = responseObj.platformCampaign.map((item, index) => {
          return { label: item.value, value: item.key };
        });

        const status = responseObj.status.map((item, index) => {
          return { label: item.value, value: item.key };
        });


        let filteredSelectedAdvertiser = [];

        if (advsData && advsData.length === 1 && istenantAgency) {
          filteredSelectedAdvertiser = advsData[0];
        } else {
          let objForAll = { label: 'All', value: -1 };
          advsData.unshift(cloneDeep(objForAll));
          filteredSelectedAdvertiser = cloneDeep(objForAll);
        }

        if (isDemoAdvertiser) {
          const demoBekiCampaign = campaignFilterData.bekiCampaign.map((item, index) => {
            return { label: item.value, value: item.key };
          });

          const demoPlatformCampaign = campaignFilterData.platformCampaign.map((item, index) => {
            return { label: item.value, value: item.key };
          });

          setBekiCampaignData([...demoBekiCampaign, ...bekiCampaign]);
          setPlatformCampaignData([...demoPlatformCampaign, ...platformCampaign]);
        } else {
          setBekiCampaignData(bekiCampaign);
          setPlatformCampaignData(platformCampaign);
        }
        setStatusData(status);
        setAdvertiserData(advsData);
      } else {
        console.log("List data not found");
      }
    })
      .catch((err) => {
        console.error(err);
        setShowSpinner(false);
      });
  };

  /**
   * campaignListResponseFormatter
   * 
   * This function formats the response data for list of campaigns in the AtdCampaign/List
   * component. It adds the "statusActionDisabled" and "disabledActions" properties to each
   * campaign object.
   * 
   * It also checks if the campaign is expired and if it is a YouTube campaign. If it is a
   * YouTube campaign, it adds the "ti ti-file-download color-beki" icon to the disabled actions.
   * If it is not editable, it adds the "ti ti-pencil color-beki" icon to the disabled actions.
   * 
   * If the user is a tenant agency, it adds the "ti ti-pencil color-beki" icon to the disabled actions
   * for all campaigns.
   * 
   * @param {object} response - The response data from the server.
   * @param {object} data - The data object passed from the parent component.
   */
  const campaignListResponseFormatter = (response, data) => {
    response.forEach((dataCmp) => {
      dataCmp["statusActionDisabled"] = dataCmp.status == 0 ? false : dataCmp.status == 1 ? false : true
      dataCmp["disabledActions"] = [...(dataCmp["disabledActions"] ? dataCmp["disabledActions"] : [])];
      if (data['isExpired'] && data['isExpired'] == 1)
        dataCmp["statusActionDisabled"] = true
      if (isTenantAgency(tenantId)) {
        dataCmp["disabledActions"].push("ti ti-pencil color-beki")
      }
      if (dataCmp.campaigns && dataCmp.campaigns.length > 0) {
        dataCmp.campaigns.forEach((dataChild) => {
          dataChild["disabledActions"] = [...(dataChild["disabledActions"] ? dataChild["disabledActions"] : [])];
          if (!dataChild.isYoutubeCampaign) {
            dataChild["disabledActions"].push("ti ti-file-download color-beki")
            dataCmp["disabledActions"].push("ti ti-file-download color-beki")
          }
          if (!dataChild.isEditable) {
            dataChild["disabledActions"].push("ti ti-pencil color-beki")
            dataCmp["disabledActions"].push("ti ti-pencil color-beki")
          }

          if (isTenantAgency(tenantId)) {
            dataChild["disabledActions"].push("ti ti-pencil color-beki");
          }
          dataChild["statusActionDisabled"] = dataChild.status == 0 ? false : dataChild.status == 1 ? false : true

        })
      }
    })
  }

  const listCampaign = async () => {
    // const { tenantId, authToken, userId, postCampaignListAllAction, configurationList } = this.props;
    // const { platformFilter, campaignFilter, creativeFilter, istenantAgency, advertiserFilter } = this.state;


    const bekiCampaignFilterData = bekiCampaignFilter.map((item, index) => {
      return { value: item.label, id: item.value } || [];
    });

    const platformCampaignFilterData = platformCampaignFilter.map((item, index) => {
      return { value: item.label, id: item.value } || [];
    });

    const advData = [];
    if (Object.keys(advertiserFilter).length > 0) {
      if (advertiserFilter.value !== -1) {
        advData.push({ id: advertiserFilter.value, value: advertiserFilter.label });
      }
    }

    // const statusFilterData = statusFilter.map((item, index) => {
    //   return { value: item.label, id: item.value } || [];
    // });

    const statusData = [];
    if (Object.keys(statusFilter).length > 0) {
      if (statusFilter.value !== -1) {
        statusData.push({ key: statusFilter.value, value: statusFilter.label });
      }
    }

    // {
    //   "advertiserId":260,
    //   "bekiCampaign":["abc1"],
    //   "campaign":["abc2","abc3"],
    //   "status":0
    // }

    let payload = {
      advertiserId: advData,
      bekiCampaign: bekiCampaignFilterData,
      platformCampaign: platformCampaignFilterData,
      status: statusData,
    };

    await dispatch(postCampaignListAllAction({ tenantId, authToken, userId, payload })).then((data) => {

      // console.log("data", data)
      let {
        responseCode: { status = "" },
        response = [],
      } = data;

      if (status === "Success") {

        campaignListResponseFormatter(response, data);

        if (isDemoAdvertiser) {
          const demoResponse = campaignList;
          campaignListResponseFormatter(demoResponse, data);
          setListCampaignModal([...response, ...demoResponse]);
          setCampaignListDataInitial([...response, ...demoResponse]);
          setIsInitialApiCallCompleted(true)

          getCampaignDashboardData({ campaignData: [...response, ...demoResponse], setInitialData: true })

        } else {
          setListCampaignModal(response);
          setCampaignListDataInitial(response);
          setIsInitialApiCallCompleted(true)

          getCampaignDashboardData({ campaignData: response, setInitialData: true })
        }


      } else {
        setShowSpinner(false);
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
        setShowSpinner(false);
      });
  };

  const getCampaignDashboardData = ({ campaignData, setInitialData }) => {
    const campaignIds = campaignData.reduce((acc, item) => {
      if (item.campaigns && Array.isArray(item.campaigns)) {
        acc.push(...item.campaigns.map(campaign => campaign.campaignId));
      }
      return acc;
    }, []);

    const params = {
      list: "total"
    }
    let payload = {
      "advertisers": [],
      "campaigns": [],
      "cmpId": [
        {
          "id": campaignIds
        }
      ],
      "platforms": [],
      "creativeTypes": [],
    }

    let clonedCampaignData = cloneDeep(campaignData);


    // remove this after server side pagination ******************

    if (dashboardCampaignIds.length > 0) {
      clonedCampaignData.forEach(record => {
        let isDataPresent = false;
        record.campaigns.forEach(campaign => {
          if (dashboardCampaignIds.includes(parseInt(campaign.campaignId))) {
            isDataPresent = true;
            campaign.isDataPresent = true;
          } else {
            campaign.isDataPresent = false;
          }
        });
        record.isDataPresent = isDataPresent;
      });
      setListCampaignModal(clonedCampaignData)
      return;
    }

    dispatch(postCampaignAvailableDashboadDataAction({ tenantId, authToken, userId, params, payload, showSpinner: true })).then((data) => {
      const { responseCode: { status = "" }, responseList = [] } = data;

      if (isApiCallSuccess(status)) {
        const cpmIds = responseList.map(cpm => parseInt(cpm.cpmId));
        clonedCampaignData.forEach(record => {
          let isDataPresent = false;
          if (record.campaigns) {
            record.campaigns.forEach(campaign => {
              if (cpmIds.includes(parseInt(campaign.campaignId))) {
                isDataPresent = true;
                campaign.isDataPresent = true;
              } else {
                campaign.isDataPresent = false;
              }
            });
          }
          record.isDataPresent = isDataPresent;
        });
        setDashboardCampaignIds(cpmIds);
        setListCampaignModal(clonedCampaignData)
        if (setInitialData) {
          setCampaignListDataInitial(clonedCampaignData)
        }
      }
      setShowSpinner(false);
    }).catch((err) => {
      setShowSpinner(false);
      console.log(err);
    })
  }

  // Apply filter
  const filterListCampaign = async () => {
    const bekiCampaignFilterData = bekiCampaignFilter.map((item, index) => {
      return { value: item.label, key: item.value } || [];
    });

    const platformCampaignFilterData = platformCampaignFilter.map((item, index) => {
      return { value: item.label, key: item.value } || [];
    });

    const statusData = [];
    if (Object.keys(statusFilter).length > 0) {
      if (statusFilter.value !== -1) {
        statusData.push({ key: statusFilter.value, value: statusFilter.label });
      }
    }

    const advData = [];
    if (Object.keys(advertiserFilter).length > 0) {
      if (advertiserFilter.value !== -1) {
        advData.push({ key: advertiserFilter.value, value: advertiserFilter.label });
      }
    }

    let payload = {
      advertiserId: advData,
      bekiCampaign: bekiCampaignFilterData,
      platformCampaign: platformCampaignFilterData,
      status: statusData,
    };
    // payload
    // console.log("payload", payload)
    // console.log(campaignListDataInitial, 'campaignListDataInitial')

    if (isDemoAdvertiser) {

      // filter beki campaigns
      const bekiCampaignList = bekiCampaignFilterData.map((data) => {
        return campaignListDataInitial.filter((list) => list.campaignId == data.key);
      }).flat();

      // filter platform campaigns
      const platformCampaignList = platformCampaignFilterData.reduce((acc, data) => {
        campaignListDataInitial.forEach((list) => {
          if (Array.isArray(list.campaigns)) {
            const hasMatchingCampaign = list.campaigns.some(
              (listChild) => listChild.campaignId == data.key
            );

            if (hasMatchingCampaign) {
              acc.push(list);
            }
          }
        });
        return acc;
      }, []);

      // prepare demo list
      const demoList = _.uniqBy([...bekiCampaignList, ...platformCampaignList], "campaignId");
      let statusCampaignList = [];

      // handle status filter to get the final demo list
      if (statusData.length > 0) {
        if (bekiCampaignList.length > 0 || platformCampaignList.length > 0) {
          statusCampaignList = statusData.map((data) => {
            return demoList.filter((list) => list.status == data.key);
          }).flat();
        } else {
          statusCampaignList = statusData.map((data) => {
            return campaignListDataInitial.filter((list) => list.status == data.key);
          }).flat();
        }
      } else {
        statusCampaignList = demoList;
      }

      statusCampaignList.forEach((dataCmp) => {
        if (dataCmp.campaigns && dataCmp.campaigns.length > 0) {
          dataCmp.campaigns.forEach((dataChild) => {
            dataChild["disabledActions"] = [...(dataChild["disabledActions"] ? dataChild["disabledActions"] : [])];
            if (!dataChild.isEditable) {
              dataChild["disabledActions"].push("ti ti-pencil color-beki")
            }
            dataChild["statusActionDisabled"] = dataChild.status == 0 ? false : dataChild.status == 1 ? false : true

          })
        }
      })

      setListCampaignModal(statusCampaignList);
      getCampaignDashboardData({ campaignData: statusCampaignList, setInitialData: false })
      togglePopover();
      return
    }

    await dispatch(postCampaignFilterAction({ tenantId, authToken, userId, payload })).then((data) => {

      // console.log("data", data)
      const {
        responseCode: { status = "" },
        response = [],
      } = data;

      if (status === "Success") {

        response.forEach((dataCmp) => {
          dataCmp["statusActionDisabled"] = dataCmp.status == 0 ? false : dataCmp.status == 1 ? false : true
          if (data['isExpired'] && data['isExpired'] == 1)
            dataCmp["statusActionDisabled"] = true
          if (dataCmp.campaigns && dataCmp.campaigns.length > 0) {
            dataCmp.campaigns.forEach((dataChild) => {
              dataChild["disabledActions"] = [...(dataChild["disabledActions"] ? dataChild["disabledActions"] : [])];
              if (!dataChild.isEditable) {
                dataChild["disabledActions"].push("ti ti-pencil color-beki")
              }
              dataChild["statusActionDisabled"] = dataChild.status == 0 ? false : dataChild.status == 1 ? false : true

            })
          }
        })

        setListCampaignModal(response);

        getCampaignDashboardData({ campaignData: response, setInitialData: false })
        togglePopover();
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  };



  const searchCampaign = async (query) => {

    if (isDemoAdvertiser) {
      const response = campaignListDataInitial.filter((data) => data.campaignName.toLowerCase().includes(query.toLowerCase()));
      response.forEach((dataCmp) => {
        dataCmp["statusActionDisabled"] = dataCmp.status == 0 ? false : dataCmp.status == 1 ? false : true
        if (dataCmp.campaigns && dataCmp.campaigns.length > 0) {
          dataCmp.campaigns.forEach((dataChild) => {
            dataChild["disabledActions"] = [...(dataChild["disabledActions"] ? dataChild["disabledActions"] : [])];
            if (!dataChild.isEditable) {
              dataChild["disabledActions"].push("ti ti-pencil color-beki")
            }
            dataChild["statusActionDisabled"] = dataChild.status == 0 ? false : dataChild.status == 1 ? false : true

          })
        }
      })

      setListCampaignModal(response);
      getCampaignDashboardData({ campaignData: response, setInitialData: false });
      return;
    }

    let payload = {
      advertiserId: [],
      bekiCampaign: [],
      platformCampaign: [],
      status: [],
    };
    // console.log("payload", payload)

    // let searchParams = form.search

    await dispatch(campaignSearchAction({ tenantId, authToken, userId, payload, searchParams: query })).then((data) => {

      // console.log("data", data)
      const {
        responseCode: { status = "" },
        response = [],
      } = data;

      if (status === "Success") {

        response.forEach((dataCmp) => {
          dataCmp["statusActionDisabled"] = dataCmp.status == 0 ? false : dataCmp.status == 1 ? false : true
          if (data['isExpired'] && data['isExpired'] == 1)
            dataCmp["statusActionDisabled"] = true
          if (dataCmp.campaigns && dataCmp.campaigns.length > 0) {
            dataCmp.campaigns.forEach((dataChild) => {
              dataChild["disabledActions"] = [...(dataChild["disabledActions"] ? dataChild["disabledActions"] : [])];
              if (!dataChild.isEditable) {
                dataChild["disabledActions"].push("ti ti-pencil color-beki")
              }
              dataChild["statusActionDisabled"] = dataChild.status == 0 ? false : dataChild.status == 1 ? false : true

            })
          }
        })


        setListCampaignModal(response);
        getCampaignDashboardData({ campaignData: response, setInitialData: false });
      } else {
        console.log("List data not found");
      }
    })
      .catch((error) => {
        console.error(error);
      });
  };




  const editCampagin = (campaignId) => {
    const { match, history } = props;
    history.push(`${match.path}/${routes.campaign.edit}/${campaignId}`);
  };

  const handleFilterChange = (selected, name) => {
    if (name === "advertiser") {
      setAdvertiserFilter(selected);
    } else if (name === "campaign") {
      setBekiCampaignFilter(selected);
    } else if (name === "platform") {
      setPlatformCampaignFilter(selected);
    } else if (name === "status") {
      setStatusFilter(selected);
    }
  };

  const handleActionError = (row, action) => {
    if (action.type === 'edit') {
      editCampagin(row.campaignId);
    }
  };

  const handleButton = async (action) => {
    // const { platformFilter, campaignFilter, creativeFilter } = state;

    if (action === "apply") {
      setCurrentIndexForPagination(1);
      await listCampaign();
    }

    if (action === "reset") {
      // console.log("Platform Campaign Filter:", platformCampaignFilter);
      // console.log("Beki Campaign Filter:", bekiCampaignFilter);
      // console.log("Status Filter:", statusFilter);

      const combinedFilters = [
        ...(Array.isArray(platformCampaignFilter) ? platformCampaignFilter : []),
        ...(Array.isArray(bekiCampaignFilter) ? bekiCampaignFilter : []),
        ...(statusFilter ? [statusFilter] : []),
      ];

      if (combinedFilters.length > 0 || (advertiserFilter && advertiserFilter.value !== -1)) {
        // setPlatformCampaignFilter([]);
        // setBekiCampaignFilter([]);
        // setStatusFilter([]);
        // setCurrentIndexForPagination(1);
        // setAdvertiserFilter({ label: 'All', value: -1 });
        // await listCampaign();


        setPlatformCampaignFilter([]);
        setBekiCampaignFilter([]);
        setStatusFilter([]); // This will set the statusFilter to empty
        setCurrentIndexForPagination(1);
        setAdvertiserFilter({ label: 'All', value: -1 });

        // Now, trigger the listCampaign call after the state updates
        setTriggerListCampaign(true);
      }
    }
  };

  useEffect(() => {
    if (triggerListCampaign) {
      listCampaign(); // Now listCampaign is called after state has updated
      setTriggerListCampaign(false); // Reset the trigger
    }
  }, [triggerListCampaign]);


  const setCurrentPageIndexForPagination = (page) => {
    setCurrentIndexForPagination(page);
  };

  const routeToDashBoardSecondScreen = async (item) => {
    const { history } = props;

    const currentDate = getCurrentDateInTimeZone(targetTimeZone);

    const defaultDate = currentDate; // Example default date in YYYY-MM-DDTHH:mm:ss format
    const defaultMoment = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
    const defaultMomentEnd = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
    const sDate = defaultMoment.subtract(7, 'days');
    const eDate = defaultMomentEnd.subtract(1, 'days');
    const formattedSDate = sDate.format('YYYY-MM-DD');
    const formattedEDate = eDate.format('YYYY-MM-DD');

    const dateRange = {
      sdate: formattedSDate,
      edate: formattedEDate
    };

    localStorage.setItem("dateRange", JSON.stringify(dateRange));

    const x = item.campaigns.map(item1 => {
      return {
        "value": item1.campaignId ? item1.campaignId : -1,
        "label": item1.campaignName ? item1.campaignName : '',
        "name": "campaign"
      }
    })
    await dispatch(clearAllReduxDataDashoardScreen1()).then(async (data) => {
      const location = {
        pathname: `/${routes.mainRoute}/${routes.containers.dashboard}`,
        state: {
          data: {
            campaigns: x,
            screen: 'first'
          }
        }
      };
      history.push(location);
    })
  };

  // const handleStatus = (type, campaignId, status = -1, recordId, customerId = "0") => {
  //   let rowDeleteData = {
  //     type,
  //     campaignId,
  //     status,
  //     recordId,
  //     customerId
  //   };

  //   setEnableToast(true);
  //   setConfirmationMsg(`Are you sure you want to ${getStatusValue(status).toLowerCase() === 'active' ? 'inactive' : 'active'} this campaign ?`);
  //   setToastMsg("");
  //   setToastStatus("");
  //   setMethod('recActiveStatus');
  //   setDeleteData(rowDeleteData);
  // };

  const handleStatusUpdate = async () => {
    // const { campModalValue, listCampaignModal, deleteData } = state;

    if (Object.keys(deleteData).length > 0) {
      const { status, campaignId, recordId, type, customerId } = deleteData;
      let clonedcampModalData = _.cloneDeep(campModalValue);
      let listDataCloned = _.cloneDeep(listCampaignModal);
      let objForStatus = {
        "CampaignDetails": {
          "platforms": [],
          "campaignId": campaignId,
          "status": getReverseIdValue(status)
        }
      };

      if (type === "google") {
        objForStatus["CampaignDetails"]["platforms"].push("Google Adwords");
        objForStatus["CampaignDetails"]["customerId"] = customerId;
      }
      if (type === "facebook") {
        objForStatus["CampaignDetails"]["platforms"].push("Facebook");
      }

      if (type === "dv") {
        objForStatus["CampaignDetails"]["platforms"].push("DV  360");
        objForStatus["CampaignDetails"]["customerDetails"] = { "dv360AccountId": customerId };
      }

      if (type === "tiktok") {
        objForStatus["CampaignDetails"]["platforms"].push("TikTok");
      }

      if (type === "ion") {
        objForStatus["CampaignDetails"]["platforms"].push("ION");
        objForStatus["CampaignDetails"]["customerId"] = customerId;
      }

      const { tenantId, authToken, userId, updateCampaignStatusAction } = props;
      const respone = await updateCampaignStatusAction({ tenantId, authToken, userId, payload: objForStatus });

      let key = Object.keys(respone);

      if (key.length > 0 && respone && respone[key[0]].responseCode && respone[key[0]].responseCode.status === "Success") {
        Object.keys(clonedcampModalData.platCampDetails).forEach((platFormName, index) => {
          let indexPlat = -1;
          let indexListData = -1;

          indexPlat = clonedcampModalData.platCampDetails[platFormName].findIndex((eachContentTypeData) => eachContentTypeData.Cmpid == campaignId);
          indexListData = listDataCloned.findIndex((dataList) => dataList.id == recordId);

          if (indexPlat > -1 && indexListData > -1) {
            clonedcampModalData.platCampDetails[platFormName][indexPlat].status.id = getReverseIdValue(status);
            clonedcampModalData.platCampDetails[platFormName][indexPlat].status.value = getReverseStatusValue(status);
            listDataCloned[indexListData] = clonedcampModalData;
          }
        });

        setCampModalValue(clonedcampModalData);
        setListCampaignModal(listDataCloned);
        await listCampaign();
        setEnableToast(true);
        setConfirmationMsg("");
        setToastMsg(respone[key[0]].responseCode.msg ? respone[key[0]].responseCode.msg : "Success");
        setToastStatus("success");
      } else if (respone && respone[key[0]].responseCode && respone[key[0]].responseCode.status === "Fail") {
        setEnableToast(true);
        setConfirmationMsg("");
        setToastMsg(respone[key[0]].responseCode.msg ? respone[key[0]].responseCode.msg : "Error");
        setToastStatus("error");
      }
    }
  };

  // status map with backend
  const getStatusValue = (id) => {
    switch (parseInt(id)) {
      case 1:
      case 3:
      case 5:
        return 'ACTIVE';
      case 2:
      case 4:
      case 6:
        return 'INACTIVE';
      default:
        return 'UNKNOWN';
    }
  };

  const getReverseStatusValue = (id) => {
    const idMap = {
      1: 'Inactive',
      2: 'Active',
      3: 'Inactive',
      4: 'Yet to be Live',
      5: 'Expired',
      6: 'Expired'
    };

    return idMap[id];
  };

  const getReverseIdValue = (status) => {
    const reverseMap = {
      'ACTIVE': 1,
      'INACTIVE': 2,
      'YET TO BE LIVE': 4,
      'EXPIRED': 5,
      'RUNNING': 1
    };

    return reverseMap[status];
  };

  const { match } = props;
  // console.log("match", match, props)


  // let clonedOptionListData = cloneDeep(optionsList);
  // if (isSemiSuspendedOrNot == 0 || isSemiSuspendedOrNot == 2 || (campaignAcessDetails && campaignAcessDetails.hasOwnProperty("type") && campaignAcessDetails.type == 0)) {
  //   clonedOptionListData.actionsThead = false
  // } else {
  //   clonedOptionListData.actionsThead = true
  // }


  // if (!istenantAgency && clonedOptionListData && clonedOptionListData.columns) {
  //   clonedOptionListData.columns = clonedOptionListData.columns.filter((dataCol) => dataCol.name != 'advertiser');
  // }


  const handleTouch = (e) => {
    const { name } = e.target;
    const { error } = handleFieldError(form[name], formFields[name]);

    setErrors({ ...errors, [name]: error });
    setTouched({ ...touched, [name]: true });
  };

  const togglePopover = () => {
    setPopoverVisible((prev) => !prev);
  };

  const handleOutsideClick = useCallback(
    (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        popoverVisible
      ) {
        setPopoverVisible(false);
      }
    },
    [popoverVisible]
  );

  useEffect(() => {
    const eventName = 'click';
    const eventHandler = (e) => {
      // Listen to events in capturing phase to ensure proper handling
      document.addEventListener(eventName, handleOutsideClick, true); // true for capturing
    };

    if (popoverVisible) {
      document.addEventListener(eventName, handleOutsideClick, true); // true to capture early
    } else {
      document.removeEventListener(eventName, handleOutsideClick, true);
    }

    return () => {
      document.removeEventListener(eventName, handleOutsideClick, true);
    };
  }, [popoverVisible, handleOutsideClick]);

  const toast = (status, msg, type) => {
    setEnableToast(true);
    setToastStatus(status);
    setToastMsg(msg);
    return;
  }

  const handleToastStatus = async (status) => {
    setEnableToast(status);
    listCampaign();


  };

  const confirmationCallbackModel = () => {
    setEnableToast(false);

    if (method === "recActiveStatus") {
      handleStatusUpdate();
    }
  };


  let optionForTable = _.cloneDeep(optionsList);

  if (!istenantAgency || (advertiserFilter.label && advertiserFilter.label != 'All')) {
    optionForTable.columns = optionForTable.columns.filter((dataCol) => dataCol.id != 5);
  }

  const handlePlanClick = (isRecommended) => () => {
    // localStorage.setItem('isRecommendedPlan', String(isRecommended));
    const { history } = props;
    // setIsRecommendedPlanSelected(isRecommended);
    dispatch(setStepperEditAction({ stepperValue: 0, screen: '' }));
    dispatch(
      basicDetailsReduxAction({
        basicDetailsForm: {}
      })
    );
    dispatch(
      customPlanReduxAction({
        customDetailsForm: {},
        customPlanResponse: {}
      })
    );
    dispatch(strategyListReduxAction({
      strategyData: {}
    }));
    dispatch(setPreferenceListReduxAction({
      preferenceData: {}
    }));
    dispatch(
      recommendedPlanAction({
        recommendedPlanData: {}
      })
    );
    dispatch(strategyCreativeDataAction({ data: {} }))
    const location = {
      pathname: `/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.add}`,
      state: {
        data: {
          childCampaignId: -1,
          isChildEdit: false,
          isRecomended: isRecommended
        }
      }
    };
    history.push(location);
  };


  const sortCampaigns = (list) => {
    return list.sort((a, b) => {
      const createdOnA = new Date(a.createdOn).getTime();
      const createdOnB = new Date(b.createdOn).getTime();

      // If modifiedOn is present, use it for comparison
      if (a.modifiedOn && b.modifiedOn) {
        const modifiedOnA = new Date(a.modifiedOn).getTime();
        const modifiedOnB = new Date(b.modifiedOn).getTime();

        return modifiedOnB - modifiedOnA || createdOnB - createdOnA;
      }

      // If modifiedOn is not present for one of the objects, use only createdOn
      return createdOnB - createdOnA;
    });
  }
  let statusType = ""
  let handleCampaignPermission = ""
  if (camapignAccess && Object.keys(camapignAccess).length > 0 && camapignAccess.hasOwnProperty('entirePlanStatus')) {
    statusType = camapignAccess.entirePlanStatus
    const getPlanPermissionData = camapignAccess.campaign
    handleCampaignPermission = getPlanPermissionData && getPlanPermissionData.length > 0 && getPlanPermissionData[0].access
  }
  const isCampaignAccess = handleCampaignPermission == accessCheck.FULL_ACCESS || handleCampaignPermission == accessCheck.WRITE_ACCESS;
  // if(!isCampaignAccess){
  //   optionForTable.actionsThead= false
  // }

  let handleRecoPermission = ""
  if (recoAccess && recoAccess.length > 0) {
    handleRecoPermission = recoAccess[0].access
  }

  const isRecoAccess = handleRecoPermission == accessCheck.FULL_ACCESS || handleRecoPermission == accessCheck.WRITE_ACCESS;




  // console.log("form", form)

  return (
    <React.Fragment>
      {
        enableToast && <ToastModal
          enableToast={enableToast}
          status={toastStatus}
          msg={toastMsg}
          // path={routes.containers.admin + '/' + routes.admin.account.name}
          idProps={props}
          handleConfirmation={confirmationCallbackModel}
          handleToastStatus={handleToastStatus}
          confirmationMsg={confirmationMsg}
          poc={true}
          outSideClickEnable={false}
        />
      }
      {
        showSpinner &&
        <Spinner />
      }

      <div className="main-panel ion campaign-list">

        <Modal open={viewError} size="large">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Campaign Error</h5>
              <button type="button" onClick={() => this.setState({ viewError: !viewError })} className="close" data-dismiss="modal" aria-label="Close">
                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
              </button>
            </div>
            {istenantAgency && (

              <div class="mx-3"><h6 style={{ backgroundColor: "#F4F4F5", padding: 9, color: "#ff4646", marginBottom: 0 }}>
                To edit the campaign, please select an Advertiser from the tenant list.
              </h6>
              </div>
            )}
            <div className='modal-body error-table-adj inputUI'>
              <Table
                options={optionsError}
                data={errorData || []}
                handelAction={handleActionError}
                hideActionColumn={istenantAgency}
              />
            </div>
          </div>

        </Modal>

        <Modal open={viewCampaign} size="large">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Campaign Details</h5>
              <button type="button" onClick={() => { this.setState({ viewCampaign: !viewCampaign }) }} className="close" data-dismiss="modal" aria-label="Close">
                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
              </button>
            </div>
            {istenantAgency && (

              <div class="mx-4 px-3"><h6 style={{ backgroundColor: "#F4F4F5", padding: 9, color: "#ff4646", marginBottom: 0 }}>
                To edit the campaign, please select an Advertiser from the tenant list.
              </h6>
              </div>
            )}
            <div className='modal-body inputUI'>
              <div className='row'>
                {
                  campModalValue.platCampDetails != undefined && campModalValue.platCampDetails.google != undefined && campModalValue.platCampDetails.google.length > 0 ?
                    <div className='col-md-12'>
                      <div className='cardModalBody newTable-adj'>
                        <h5>Google Adwords</h5>
                        <table className='table-responsvie w-100'>
                          <thead>
                            <th style={{ minWidth: 112 }}>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th width="250" style={{ padding: 0 }}>Duration</th>
                            <th>Creative Type</th>
                            <th>Budget</th>
                            {!istenantAgency && <th>Action</th>}
                          </thead>
                          <tbody>
                            {
                              campModalValue.platCampDetails.google.map((item, index) =>
                                <tr>
                                  <td>{item.Cmpid}</td>
                                  <td title={item.PltName}>{item.PltName.length > 40 ? `${item.PltName.slice(0, 40)}...` : item.PltName}</td>
                                  <td>{(item.status && item.status.value) ? item.status.value : ''}</td>
                                  <td>{item.duration}</td>
                                  <td>{item.creativeType == 0 ? "Display" : item.creativeType == 1 ? "Video" : item.creativeType == 2 ? "Search" : ""}</td>
                                  <td>{item.budget}</td>

                                  {!istenantAgency && <td className='d-flex'>
                                    {item.hasOwnProperty("isAtdCampaign") && parseInt(item.isAtdCampaign) === 0 &&
                                      <button class="actionButton-adj" onClick={() => editCampagin(item.Cmpid)}>
                                        <i className='mdi mdi-pencil'></i>
                                      </button>
                                    }
                                    {
                                      getStatusValue(item.status.id) === "ACTIVE" ?
                                        <button className='activeCamp' onClick={() => handleStatus("google", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-checkbox-marked'></i>
                                        </button>
                                        :
                                        <button className='inactiveCamp' onClick={() => handleStatus("google", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-close-box'></i>
                                        </button>
                                    }
                                    {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) &&
                                      <button title={`${!item.areStatsPresent ? noMetricMessage : ''}`} className={`${!item.areStatsPresent ? 'opacityDecrease' : ''}`} disabled={!item.areStatsPresent} onClick={() => this.routeToDashBoardSecondScreen(item)}>
                                        <i className='mdi mdi-chart-areaspline'></i>
                                      </button>
                                    }
                                  </td>}
                                </tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div> : ""
                }

                {
                  campModalValue.platCampDetails != undefined && campModalValue.platCampDetails.dv360 != undefined && campModalValue.platCampDetails.dv360.length > 0 ?
                    <div className='col-md-12'>
                      <div className='cardModalBody newTable-adj'>
                        <h5>DV 360</h5>
                        <table className='table-responsvie w-100'>
                          <thead>
                            <th style={{ minWidth: 112 }}>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th width="250" style={{ padding: 0 }}>Duration</th>
                            <th>Creative Type</th>
                            <th>Budget</th>
                            {!istenantAgency && <th>Action</th>}
                          </thead>
                          <tbody>
                            {
                              campModalValue.platCampDetails.dv360.map((item, index) =>
                                <tr>
                                  <td>{item.Cmpid}</td>
                                  <td title={item.PltName}>{item.PltName.length > 40 ? `${item.PltName.slice(0, 40)}...` : item.PltName}</td>
                                  <td>{(item.status && item.status.value) ? item.status.value : ''}</td>
                                  <td>{item.duration}</td>
                                  <td>{item.creativeType == 0 ? "Display" : item.creativeType == 1 ? "Video" : item.creativeType == 2 ? "Search" : ""}</td>
                                  <td>{item.budget}</td>
                                  {!istenantAgency && <td className='d-flex'>
                                    {
                                      item.hasOwnProperty("isAtdCampaign") && parseInt(item.isAtdCampaign) === 0 &&
                                      <button onClick={() => editCampagin(item.Cmpid)}>
                                        <i className='mdi mdi-pencil'></i>
                                      </button>
                                    }
                                    {
                                      getStatusValue(item.status.id) === "ACTIVE" ?
                                        <button className='activeCamp' onClick={() => handleStatus("dv", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-checkbox-marked'></i>
                                        </button>
                                        :
                                        <button className='inactiveCamp' onClick={() => handleStatus("dv", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-close-box'></i>
                                        </button>
                                    }
                                    {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) &&
                                      <button title={`${!item.areStatsPresent ? noMetricMessage : ''}`} className={`${!item.areStatsPresent ? 'opacityDecrease' : ''}`} disabled={!item.areStatsPresent} onClick={() => this.routeToDashBoardSecondScreen(item)}>
                                        <i className='mdi mdi-chart-areaspline'></i>
                                      </button>
                                    }
                                  </td>}
                                </tr>)
                            }

                          </tbody>
                        </table>
                      </div>
                    </div>
                    : ""
                }


                {
                  campModalValue.platCampDetails != undefined && campModalValue.platCampDetails.tiktok != undefined && campModalValue.platCampDetails.tiktok.length > 0 ?
                    <div className='col-md-12'>
                      <div className='cardModalBody newTable-adj'>
                        <h5>TikTok</h5>
                        <table className='table-responsvie w-100'>
                          <thead>
                            <th style={{ minWidth: 112 }}>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th width="250" style={{ padding: 0 }}>Duration</th>
                            <th>Creative Type</th>
                            <th>Budget</th>
                            {!istenantAgency && <th>Action</th>}
                          </thead>
                          <tbody>
                            {
                              campModalValue.platCampDetails.tiktok.map((item, index) =>
                                <tr>
                                  <td>{item.Cmpid}</td>
                                  <td title={item.PltName}>{item.PltName.length > 40 ? `${item.PltName.slice(0, 40)}...` : item.PltName}</td>
                                  <td>{(item.status && item.status.value) ? item.status.value : ''}</td>
                                  <td>{item.duration}</td>
                                  <td>{item.creativeType == 0 ? "Display" : item.creativeType == 1 ? "Video" : item.creativeType == 2 ? "Search" : ""}</td>
                                  <td>{item.budget}</td>
                                  {!istenantAgency && <td className='d-flex'>
                                    {
                                      item.hasOwnProperty("isAtdCampaign") && parseInt(item.isAtdCampaign) === 0 &&
                                      <button onClick={() => editCampagin(item.Cmpid)}>
                                        <i className='mdi mdi-pencil'></i>
                                      </button>
                                    }

                                    {
                                      getStatusValue(item.status.id) === "ACTIVE" ?
                                        <button className='activeCamp' onClick={() => handleStatus("tiktok", item.Cmpid, item.status.id, campModalValue.id)}>
                                          <i className='mdi mdi-checkbox-marked'></i>
                                        </button>
                                        :
                                        <button className='inactiveCamp' onClick={() => handleStatus("tiktok", item.Cmpid, item.status.id, campModalValue.id)}>
                                          <i className='mdi mdi-close-box'></i>
                                        </button>
                                    }
                                    {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) &&
                                      <button title={`${!item.areStatsPresent ? noMetricMessage : ''}`} className={`${!item.areStatsPresent ? 'opacityDecrease' : ''}`} disabled={!item.areStatsPresent} onClick={() => this.routeToDashBoardSecondScreen(item)}>
                                        <i className='mdi mdi-chart-areaspline'></i>
                                      </button>
                                    }

                                  </td>}
                                </tr>)
                            }

                          </tbody>
                        </table>
                      </div>
                    </div>
                    : ""
                }

                {
                  campModalValue.platCampDetails != undefined && campModalValue.platCampDetails.ion != undefined && campModalValue.platCampDetails.ion.length > 0 ?
                    <div className='col-md-12'>
                      <div className='cardModalBody newTable-adj'>
                        <h5>ION</h5>
                        <table className='table-responsvie w-100'>
                          <thead>
                            <th style={{ minWidth: 112 }}>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th width="250" style={{ padding: 0 }}>Duration</th>
                            <th>Creative Type</th>
                            <th>Budget</th>
                            {!istenantAgency && <th>Action</th>}
                          </thead>
                          <tbody>
                            {
                              campModalValue.platCampDetails.ion.map((item, index) =>
                                <tr>
                                  <td>{item.Cmpid}</td>
                                  <td title={item.PltName}>{item.PltName.length > 40 ? `${item.PltName.slice(0, 40)}...` : item.PltName}</td>
                                  <td>{(item.status && item.status.value) ? item.status.value : ''}</td>
                                  <td>{item.duration}</td>
                                  <td>{item.creativeType == 0 ? "Display" : item.creativeType == 1 ? "Video" : item.creativeType == 2 ? "Search" : ""}</td>
                                  <td>{item.budget}</td>
                                  {!istenantAgency && <td className='d-flex'>
                                    {
                                      item.hasOwnProperty("isAtdCampaign") && parseInt(item.isAtdCampaign) === 0 &&
                                      <button onClick={() => editCampagin(item.Cmpid)}>
                                        <i className='mdi mdi-pencil'></i>
                                      </button>
                                    }

                                    {
                                      getStatusValue(item.status.id) === "ACTIVE" ?
                                        <button className='activeCamp' onClick={() => handleStatus("ion", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-checkbox-marked'></i>
                                        </button>
                                        :
                                        <button className='inactiveCamp' onClick={() => handleStatus("ion", item.Cmpid, item.status.id, campModalValue.id, item.customerId)}>
                                          <i className='mdi mdi-close-box'></i>
                                        </button>
                                    }
                                    {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) &&
                                      <button title={`${!item.areStatsPresent ? noMetricMessage : ''}`} className={`${!item.areStatsPresent ? 'opacityDecrease' : ''}`} disabled={!item.areStatsPresent} onClick={() => this.routeToDashBoardSecondScreen(item)}>
                                        <i className='mdi mdi-chart-areaspline'></i>
                                      </button>
                                    }
                                  </td>}
                                </tr>)
                            }

                          </tbody>
                        </table>
                      </div>
                    </div>
                    : ""
                }


                {
                  campModalValue.platCampDetails != undefined && campModalValue.platCampDetails.facebook != undefined && campModalValue.platCampDetails.facebook.length > 0 ?
                    <div className='col-md-12'>
                      <div className='cardModalBody newTable-adj'>
                        <h5>Facebook</h5>
                        <table className='table-responsvie w-100'>
                          <thead>
                            <th style={{ minWidth: 112 }}>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Status</th>
                            <th width="250" style={{ padding: 0 }}>Duration</th>
                            <th>Creative Type</th>
                            <th>Budget</th>
                            {!istenantAgency && <th>Action</th>}
                          </thead>
                          <tbody>
                            {
                              campModalValue.platCampDetails.facebook.map((item, index) =>
                                <tr>
                                  <td>{item.Cmpid}</td>
                                  <td title={item.PltName}>{item.PltName.length > 40 ? `${item.PltName.slice(0, 40)}...` : item.PltName}</td>
                                  <td>{(item.status && item.status.value) ? item.status.value : ''}</td>
                                  <td>{item.duration}</td>
                                  <td>{item.creativeType == 0 ? "Display" : item.creativeType == 1 ? "Video" : item.creativeType == 2 ? "Search" : ""}</td>
                                  <td>{item.budget}</td>
                                  {!istenantAgency && <td className='d-flex'>
                                    {
                                      item.hasOwnProperty("isAtdCampaign") && parseInt(item.isAtdCampaign) === 0 &&
                                      <button class="actionButton-adj" onClick={() => editCampagin(item.Cmpid)}>
                                        <i className='mdi mdi-pencil'></i>
                                      </button>
                                    }
                                    {
                                      getStatusValue(item.status.id) === "ACTIVE" ?
                                        <button className='activeCamp' onClick={() => handleStatus("facebook", item.Cmpid, item.status.id, campModalValue.id)}>
                                          <i className='mdi mdi-checkbox-marked'></i>
                                        </button>
                                        :
                                        <button className='inactiveCamp' onClick={() => handleStatus("facebook", item.Cmpid, item.status.id, campModalValue.id)}>
                                          <i className='mdi mdi-close-box'></i>
                                        </button>
                                    }
                                    {checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) &&
                                      <button title={`${!item.areStatsPresent ? noMetricMessage : ''}`} className={`${!item.areStatsPresent ? 'opacityDecrease' : ''}`} disabled={!item.areStatsPresent} onClick={() => this.routeToDashBoardSecondScreen(item)}>
                                        <i className='mdi mdi-chart-areaspline'></i>
                                      </button>
                                    }
                                  </td>}
                                </tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div> : ""
                }
              </div>

            </div>
          </div>

        </Modal>

        <div className="content-wrapper">
          <BreadCrumb />
          <div className='px-3'>
            <SubspendMessage statusType={statusType} />

          </div>

          {/* {
            isSemiSuspendedOrNot !== undefined && isSemiSuspendedOrNot == 0 && showSuspendDiv ?
              <>
                <div className="alert alert-danger mt-3" role="alert">
                  Your account is in a suspended state. Hence you currently have limited access to Campaign.
                </div>
              </> : isSemiSuspendedOrNot !== undefined && isSemiSuspendedOrNot == 2 ?
                <>
                  <div className="alert alert-danger mt-3" role="alert">
                    Your account is in a semi-suspended state. Hence you currently have limited access to Campaign.
                  </div>
                </> : ''
          } */}
          <div className="row mt-3 parentDiv">

            {((isInitialApiCallCompleted && campaignListDataInitial.length > 0) || istenantAgency) &&
              <React.Fragment>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <div className='d-flex align-items-center pl-3 position-relative'>
                    <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={togglePopover}>
                      <i className='ti ti-filter ti-sm'></i>
                      Filters
                    </button>
                    {popoverVisible && (
                      // <div ref={popoverRef} className="popover" onClick={(e) => e.stopPropagation()}>
                      <div
                        ref={popoverRef}
                        className="popover"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevents click event propagation from closing popover
                        }}
                      >

                        <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                          <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                          <button className='close close-popover' onClick={togglePopover}>
                            &times;
                          </button>
                        </div>

                        <div className='row flex-column p-3'>
                          {
                            <div className='col-md-12 mb-2'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <label>Advertiser Name</label>
                                  <Select
                                    options={advertiserData}
                                    isMulti={false}
                                    placeholder="All"
                                    defaultValue={istenantAgency || isPlatformManager == "Platform Manager" ? advertiserFilter : advertiserData[1]}
                                    value={istenantAgency || isPlatformManager == "Platform Manager" ? advertiserFilter : advertiserData[1]}
                                    onChange={(selected) => handleFilterChange(selected, "advertiser")}
                                    className="campaignFilter my-2"
                                    isDisabled={(!istenantAgency && isPlatformManager !== "Platform Manager")}
                                  />
                                </div>
                              </div>
                            </div>
                          }
                          <div className='col-md-12 mb-2'>
                            <label>Beki Campaign Name </label>
                            <Select
                              options={bekiCampaignData}
                              isMulti={true}
                              placeholder="Select Campaign"
                              defaultValue={bekiCampaignFilter}
                              value={bekiCampaignFilter}
                              onChange={(selected) => handleFilterChange(selected, "campaign")}
                              className="campaignFilter my-2"
                            />
                          </div>
                          <div className='col-md-12 mb-2'>
                            <label className="mr-2">Platform Campaign Name </label>
                            <Select
                              options={platformCampaignData}
                              isMulti={true}
                              placeholder="Select Platform Campaign"
                              defaultValue={platformCampaignFilter}
                              value={platformCampaignFilter}
                              onChange={(selected) => handleFilterChange(selected, "platform")}
                              className="campaignFilter my-2"
                            />
                          </div>
                          <div className='col-md-12 mb-2'>
                            <label className="mr-2">Status </label>
                            <Select
                              options={statusData}
                              isMulti={false}
                              placeholder="Select Status"
                              defaultValue={statusFilter}
                              value={statusFilter}
                              onChange={(selected) => handleFilterChange(selected, "status")}
                              className="campaignFilter my-2"
                            />
                          </div>
                          <div className="col-md-12 mt-4 justify-content-end d-flex">
                            <button onClick={() => handleButton("reset")} className="btn btn-outline-primary">Reset</button>
                            <button onClick={() => filterListCampaign()} className="btn btn-primary bg-color-beki ml-3">Apply</button>
                          </div>

                        </div>
                      </div>
                    )}

                    <div className='d-flex align-items-center mt-2 ml-3 search-adj'>
                      <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                      <Input
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[formFields.search.key]}
                        setting={formFields[formFields.search.key]}
                        error={errors[formFields.search.key]}
                        submited={submited}
                        // disabled={true}
                        touched={touched[formFields.search.key]} />
                    </div>
                  </div>






                  {
                    isPlatformManager && isPlatformManager == "Platform Manager" ?
                      (checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD)) && !istenantAgency && (
                        <div className="d-flex justify-content-end pb-3">
                          <Link to={`${match.path}/${routes.campaign.add}`}>
                            <button className="btn btn-primary ml-3">
                              <i className="mdi mdi-plus"></i>
                              Campaign
                            </button>
                          </Link>
                        </div>) :
                      (checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD)) && !istenantAgency && (
                        // isSemiSuspendedOrNot == 1 || (campaignAcessDetails && campaignAcessDetails.hasOwnProperty("type") && campaignAcessDetails.type == 1) || (campaignAcessDetails && campaignAcessDetails.hasOwnProperty("type") && campaignAcessDetails.type == 2) ?
                        <div className="d-flex justify-content-end pb-3 campaign-plan-adj">
                          {
                            isCampaignAccess &&
                            // <Link to={`${match.path}/${routes.campaign.add}`}>
                            <button className="btn bg-white ml-3 px-3 py-2 mr-2" onClick={handlePlanClick(false)}>
                              Create Your Own Campaign
                            </button>
                            // </Link>
                          }

                          {
                            // isRecoAccess &&
                            // <Link to={`${match.path}/${routes.campaign.add}`}>
                            <button className="btn bg-white ml-3 px-3 py-2 mr-3" onClick={handlePlanClick(true)}>
                              Use Recommended Plan
                            </button>
                            // </Link>
                          }

                        </div>
                        // : ''
                      )
                  }
                </div>



                {/* <div class="accordion" id="accordionWithIcon">
                <div class="card accordion-item mb-2">
                  <h2 class="accordion-header d-flex align-items-center">
                    <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-1" aria-expanded="true">
                      <i class="ti ti-filter ti-xs me-2"></i>
                      Filter Campaign
                    </button>
                  </h2>

                  <div id="accordionWithIcon-1" class="accordion-collapse collapse show" >
                    <div class="accordion-body">
                      <div className='row col-md-12 p-0 pt-1'>
                        {
                          <div className='col-md-12 mb-2'>
                            <div className='row'>
                              <div className='col-md-12'>
                                <label>Advertiser Name</label>
                                <Select
                                  options={advertiserData}
                                  isMulti={false}
                                  placeholder="All"
                                  defaultValue={istenantAgency ? advertiserFilter : advertiserData[1]}
                                  value={istenantAgency ? advertiserFilter : advertiserData[1]}
                                  onChange={(selected) => handleFilterChange(selected, "advertiser")}
                                  className="campaignFilter my-2"
                                  isDisabled={!istenantAgency}
                                />
                              </div>
                            </div>
                          </div>
                        }
                        <div className='col-md-12 mb-2'>
                          <label>Beki Campaign Name </label>
                          <Select
                            options={bekiCampaignData}
                            isMulti={true}
                            placeholder="Select Campaign"
                            defaultValue={bekiCampaignFilter}
                            value={bekiCampaignFilter}
                            onChange={(selected) => handleFilterChange(selected, "campaign")}
                            className="campaignFilter my-2"
                          />
                        </div>
                        <div className='col-md-12 mb-2'>
                          <label className="mr-2">Platform Campaign Name </label>
                          <Select
                            options={platformCampaignData}
                            isMulti={true}
                            placeholder="Select Platform"
                            defaultValue={platformCampaignFilter}
                            value={platformCampaignFilter}
                            onChange={(selected) => handleFilterChange(selected, "platform")}
                            className="campaignFilter my-2"
                          />
                        </div>
                        <div className='col-md-12 mb-2'>
                          <label className="mr-2">Status </label>
                          <Select
                            options={statusData}
                            isMulti={false}
                            placeholder="Select Creative"
                            defaultValue={statusFilter}
                            value={statusFilter}
                            onChange={(selected) => handleFilterChange(selected, "creative")}
                            className="campaignFilter my-2"
                          />
                        </div>
                        <div className="col-md-12 mt-4 justify-content-end d-flex">
                          <button onClick={() => handleButton("reset")} className="btn btn-outline-primary">Cancel</button>
                          <button onClick={() => filterListCampaign()} className="btn btn-primary bg-color-beki ml-3">Apply</button>
                        </div>
  
                      </div>
                    </div>
                  )}
  
                  <div className='d-flex align-items-center mt-2 ml-3 search-adj'>
                    <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                    <Input
                      onChange={handleChange}
                      onBlur={handleTouch}
                      value={form[formFields.search.key]}
                      setting={formFields[formFields.search.key]}
                      error={errors[formFields.search.key]}
                      submited={submited}
                      // disabled={true}
                      touched={touched[formFields.search.key]} />
                  </div>
                </div>
  
                
  
  
  
  
                {
                  isPlatformManager && isPlatformManager == "Platform Manager" ?
                    (checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD)) && !istenantAgency && (
                      <div className="d-flex justify-content-end pb-3">
                        <Link to={`${match.path}/${routes.campaign.add}`}>
                          <button className="btn btn-primary ml-3">
                            <i className="mdi mdi-plus"></i>
                            Campaign
                          </button>
                        </Link>
                      </div>) :
                    (checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD)) && !istenantAgency && (
                      // isSemiSuspendedOrNot == 1 || (campaignAcessDetails && campaignAcessDetails.hasOwnProperty("type") && campaignAcessDetails.type == 1) || (campaignAcessDetails && campaignAcessDetails.hasOwnProperty("type") && campaignAcessDetails.type == 2) ?
                      <div className="d-flex justify-content-end pb-3 campaign-plan-adj">
                        {
                          isCampaignAccess &&
                        <Link to={`${match.path}/${routes.campaign.add}`}>
                          <button className="btn bg-white ml-3 px-3 py-2 mr-2" onClick={handlePlanClick(false)}>
                            Create Your Own Campaign
                          </button>
                        </Link>
                        }
  
                        {
                          isRecoAccess &&
                        <Link to={`${match.path}/${routes.campaign.add}`}>
                          <button className="btn bg-white ml-3 px-3 py-2 mr-3" onClick={handlePlanClick(true)}>
                            Use Recommended Plan
                          </button>
                        </Link>
                        }
  
                      </div>
                      // : ''
                    )
                }
              </div>
  
              
  
              {/* <div class="accordion" id="accordionWithIcon">
                  <div class="card accordion-item mb-2">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-1" aria-expanded="true">
                        <i class="ti ti-filter ti-xs me-2"></i>
                        Filter Campaign
                      </button>
                    </h2>
  
                    <div id="accordionWithIcon-1" class="accordion-collapse collapse show" >
                      <div class="accordion-body">
                        <div className='row col-md-12 p-0 pt-1'>
                          {
                            istenantAgency &&
  
                            <div className='col-md-12 mb-2'>
                              <div className='row'>
                                <div className='col-md-3'>
                                  <label>Advertiser </label>
                                  <Select
                                    options={advertiserData}
                                    isMulti={false}
                                    placeholder="All"
                                    defaultValue={advertiserFilter}
                                    value={advertiserFilter}
                                    onChange={(selected) => this.handleFilterChange(selected, "advertiser")}
                                    className="campaignFilter"
                                  />
                                </div>
                              </div>
                            </div>
                          }
  
                          <div className='col-md-3'>
                            <label>Campaign </label>
                            <Select
                              options={campaignsData}
                              isMulti={true}
                              placeholder="Select Campaign"
                              defaultValue={campaignFilter}
                              value={campaignFilter}
                              onChange={(selected) => this.handleFilterChange(selected, "campaign")}
                              className="campaignFilter"
                            />
                          </div>
                          <div className='col-md-3'>
                            <label className="mr-2">Platform </label>
                            <Select
                              options={platformsData}
                              isMulti={true}
                              placeholder="Select Platform"
                              defaultValue={platformFilter}
                              value={platformFilter}
                              onChange={(selected) => this.handleFilterChange(selected, "platform")}
                              className="campaignFilter"
                            />
                          </div>
                          <div className='col-md-3'>
                            <label className="mr-2">Creative </label>
                            <Select
                              options={creativeTypesData}
                              isMulti={true}
                              placeholder="Select Creative"
                              defaultValue={creativeFilter}
                              value={creativeFilter}
                              onChange={(selected) => this.handleFilterChange(selected, "creative")}
                              className="campaignFilter"
                            />
                          </div>
                          <div className="col-md-3 mt-4">
                            <button onClick={() => this.handleButton("apply")} className="btn btn-primary"><i className='mdi mdi-account-check'></i>Apply</button>
                            <button onClick={() => this.handleButton("reset")} className="btn ml-3 btn-primary"><i class="mdi mdi-replay"></i>Reset</button>
                          </div>
  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

                {/* <div className="table-responsive table-campaign-adj mt-5">
                <Table
                  options={clonedOptionListData}
                  data={listCampaignModal || []}
                  handelAction={handleAction}
                  currentIndex={currentIndexForPagination}
                  setCurrentPageIndexForPagination={setCurrentPageIndexForPagination}
                />
              </div> */}
                <div className='campaign-adj'>

                  <Card>
                    <div className="campaign-list-adj table-responsive">
                      <Table
                        options={optionForTable}
                        // data={listCampaignModal || []}
                        data={sortCampaigns(listCampaignModal || [])}
                        handelAction={handleAction}
                        // handleSearchChange={handleSearchChange.bind(this)}
                        expand={(row) => <ExpandTable row={row} targetTimeZone={targetTimeZone} setListCampaignModal={setListCampaignModal} togglePopover={togglePopover} listCampaign={listCampaign} toast={toast} budgetLabel={budgetLabel} />}
                      />
                    </div>
                  </Card>
                </div>
              </React.Fragment>
            }

            {
              (isInitialApiCallCompleted && !istenantAgency && campaignListDataInitial.length == 0) &&
              <Card>
                <div className='d-flex justify-content-center'>
                  <div className='planLayout'>
                    <h1 class="title">Recommended Plan Campaign</h1>
                    <div>
                      <img style={{ width: 115, height: 120 }} src={CreateRecomendedImage} alt="recomendedImage" />
                    </div>
                    <div class="campaign-details mt-3">
                      <div className=''>
                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>

                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>
                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>
                      </div>
                    </div>
                    {/* <Link to={`${match.path}/${routes.campaign.add}`}> */}

                    {
                      isRecoAccess && !istenantAgency &&
                      checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD) &&
                      <button
                        onClick={handlePlanClick(true)}
                        className="btn btn-primary bg-color-beki ml-3"
                      >
                        Create Campaign using Recommendation
                      </button>
                    }

                    {/* </Link> */}
                  </div>
                  <div className='planLayout ml-4'>
                    <h1 class="title">Create your Own Campaign</h1>
                    <div>
                      <img style={{ width: 115, height: 120 }} src={CreateOwnCampaignImage} alt="recomendedImage" />
                    </div>
                    <div class="campaign-details mt-3">
                      <div className=''>
                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>

                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>
                        <div className='d-flex align-items-center'><span>
                          <i
                            style={{ color: "#288E49" }}
                            className="mdi mdi-check-circle-outline"
                          ></i>
                        </span>
                          <p class="description ml-2">Donec sit amet erat</p></div>
                      </div>
                    </div>
                    {/* <Link to={`${match.path}/${routes.campaign.add}`}> */}
                    {
                      isCampaignAccess && !istenantAgency &&
                      checkAddPermission(PERMISSION.CAMPAIGN.CAMPAIGN.ADD) &&
                      <button
                        onClick={handlePlanClick(false)}
                        className="btn btn-primary bg-color-beki ml-3"
                      >
                        Create your Own Custom Campaign
                      </button>
                    }

                    {/* </Link> */}
                  </div>
                </div>
              </Card>

            }


            {/* } */}

          </div>
        </div>
      </div>
    </React.Fragment>
  );
}


export default withRouter(Campaign);
